function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "warning",
  d: "M29.693,39.024V33.632a.906.906,0,0,0-.269-.667.872.872,0,0,0-.638-.269H23.335a.872.872,0,0,0-.638.269.911.911,0,0,0-.271.667v5.392a.906.906,0,0,0,.269.667.872.872,0,0,0,.638.269h5.449a.872.872,0,0,0,.638-.269.906.906,0,0,0,.269-.667ZM29.636,28.41l.511-13.027a.626.626,0,0,0-.284-.54,1.1,1.1,0,0,0-.682-.312H22.937a1.1,1.1,0,0,0-.682.312.679.679,0,0,0-.284.6l.483,12.97a.545.545,0,0,0,.284.468,1.224,1.224,0,0,0,.682.184h5.25a1.153,1.153,0,0,0,.667-.184.634.634,0,0,0,.3-.468ZM29.238,1.9l21.8,39.961a3.385,3.385,0,0,1-.057,3.576,3.633,3.633,0,0,1-3.123,1.788H4.262a3.628,3.628,0,0,1-3.121-1.788,3.385,3.385,0,0,1-.057-3.576L22.882,1.9A3.626,3.626,0,0,1,24.216.512a3.589,3.589,0,0,1,3.69,0A3.626,3.626,0,0,1,29.241,1.9Z",
  transform: "translate(-0.601 -0.001)",
  fill: "#ac1ede"
});

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50.917,
    height: 47.226,
    viewBox: "0 0 50.917 47.226",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.ba1aba0f.svg";
export { ForwardRef as ReactComponent };